import ApiService from "@/common/api.service";
import JwtService from "@/common/jwt.service";
import {
  LOGIN,
  LOGOUT,
  REGISTER,
  CHECK_AUTH,
  UPDATE_USER
} from "./actions.type";
import { SET_AUTH, PURGE_AUTH, SET_ERROR } from "./mutations.type";

const state = {
  error: null,
  user: {},
  isAuthenticated: false
};

const getters = {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      console.log("credentials")
      console.log(credentials)
      ApiService.post("Accounts/login", credentials)
        .then(({ data }) => {
          console.log("then: response")
          console.log(data)
          context.commit(SET_AUTH, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log("catch: response.data.error")
          console.log(response)
          context.commit(SET_ERROR, response.data.error);
        });
    });
  },
  [LOGOUT](context) {
    context.commit(PURGE_AUTH);
  },
  [CHECK_AUTH](context) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.get(`Accounts/${JwtService.getUserId()}/accessTokens/${JwtService.getToken()}`)
          .then(({ data }) => {
            console.log(data)
            context.commit(SET_AUTH, data);
            resolve(true)
            // context.commit(SET_AUTH, {username: "Julian", email: "julian@bruening.dev", id: "cGUyjesdh5QscGpRCCsPNM4IQhbxCHCDlacwKdV21AtvkydpT8eQZ38aikEvtemD", userId: "5cb34876c5c07772f5535b49"});
          })
          .catch(({ response }) => {
            context.commit(SET_ERROR);
            resolve(false)
          });
      } else {
        context.commit(PURGE_AUTH);
        resolve(false)
      }
    })
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.error = error;
  },
  [SET_AUTH](state, user) {
    state.isAuthenticated = true;
    state.user = user;
    state.error = {};
    JwtService.saveToken(state.user.id);
    JwtService.saveUserId(state.user.userId);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.error = {};
    JwtService.destroyToken();
    JwtService.destroyUserId();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
